
import './DemandCard.css'

interface DemandCardProps {
  icon: string
  title: string
  description: string
  details?: string
}

export default function DemandCard({ 
  icon, 
  title, 
  description, 
  details 
}: DemandCardProps) {
  return (
    <div className="demand-card-component">
      <h3 className="demand-card-title">
        <span className="demand-card-icon">{icon}</span>
        {title}
      </h3>
      <p className="demand-card-description">{description}</p>
      {details && (
        <p className="demand-card-details">{details}</p>
      )}
    </div>
  )
}
